<template>
  <div>
    <Row :gutter="12" class="title">
      <Col span="24">
      <ButtonGroup class="title-left">
        <template v-if="tabName==='gradeTab'">
          <Button type="primary" v-on:click="changeStatisType('gradeTab')">成绩分析</Button>
          <Button type="ghost" v-on:click="changeStatisType('answerTab')">答题分析</Button>
        </template>
        <template v-else>
          <Button type="ghost" v-on:click="changeStatisType('gradeTab')">成绩分析</Button>
          <Button type="primary" v-on:click="changeStatisType('answerTab')">答题分析</Button>
        </template>
      </ButtonGroup>
      <div class="select_wrap">
        <!--<Select v-model="classId" @on-change="changeClass($event)">-->
          <!--<Option v-for="item in classListData" :value="item.id" :key="item.id">{{item.class_name}}</Option>-->
        <!--</Select>-->
      </div>
      </Col>
    </Row>
  </div>
</template>

<script>
  // import API from "@/api/api_report.js";

  export default {
    name: "tab-class-bar",
    props: {
    },
    data () {
      return {
        tabName: 'gradeTab',
        classId: '0',
        classListData: [],
        homeworkId:this.$route.params.homeworkId
      }
    },
    watch: {
      // homeworkId: "getClassListByWorkId"
    },
    methods: {
      /**
       * 根据作业id获取作业接收班级
       */
      async getClassListByWorkId () {
        let _this = this;
        if(_this.homeworkId!=''){
        let params = {
          workId: _this.homeworkId,
        };
        await API.findClassListByWorkId(params)
          .then(function (result) {
            if (result && parseInt(result.code) === 1) {
              _this.classListData = result.data;
              //通知主页 赋值classList
              _this.$root.Bus.$emit('initClassList', _this.classListData);
              if (_this.classListData.length > 0) {
                let curClassId = _this.$store.getters.curClassId;
                if (curClassId != "" && curClassId != 0 && curClassId != undefined) {
                  //遍历班级列表 查找班级id和curClassId相同的班级 并赋值
                  let curClassObj = _this.classListData.filter((item) => {
                    return curClassId === item.id;
                  })[0];
                  if (curClassObj != null) {
                    _this.classId = curClassObj.id;
                  }
                } else {
                  _this.classId = _this.classListData[0].id;
                }
                //通知主页 更新classId
                _this.$root.Bus.$emit('changeSelectClass', _this.classId);
              }
            }
          })
          .catch(function (error) {
            _this.$Message.error("获取班级列表请求出现异常");
          });
        }
      },
      /**
       * 切换统计类别
       */
      changeStatisType (typeName) {
        this.tabName = typeName;
        this.$root.Bus.$emit('changeHeadTabName', typeName);
      },
      /**
       * 切换班级查询
       */
      changeClass (classObj) {
        this.$store.commit('SET_CURCLASSID', classObj);
        this.$root.Bus.$emit('changeSelectClass', classObj);
      }
    },
    mounted () {
      // this.getClassListByWorkId();
    }
  }
</script>

<style lang="scss" scoped>
    @import "../style/product/homework/reportList";
</style>
